import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { resetAll } from "../lib/storage";

export default function About() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen spotlight grain scanlines">
      <div className="max-w-md mx-auto px-5 pt-6 pb-nav">
        <button data-testid="about-back-btn" onClick={() => nav("/home")} className="flex items-center gap-1 text-sm text-[#FDFBF7]/70 hover:text-[#FF107A]">
          <ArrowLeft size={16} /> Home
        </button>
        <h1 className="font-display text-5xl tracking-tight mt-4">ABOUT</h1>
        <p className="mt-3 text-[#FDFBF7]/80 leading-relaxed">
          Celebrity Smash is a social prediction game. You pick between two icons, explain what actually decided it, and predict what the crowd (or a specific friend) will do.
        </p>
        <p className="mt-3 text-[#FDFBF7]/80 leading-relaxed">
          This is a proof of concept. All data lives in your browser. The seeded majority percentages are demo values — not real polls.
        </p>

        <div className="mt-6 rounded-2xl border border-[#A855F7]/30 bg-[#A855F7]/5 p-4">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#A855F7] font-bold">The idea</div>
          <p className="mt-2 text-sm text-[#FDFBF7]/85 leading-relaxed">
            The reason behind the choice is more revealing than the choice itself.
          </p>
        </div>

        <button
          data-testid="reset-demo-btn"
          onClick={() => {
            resetAll();
            toast.success("Local demo reset.");
          }}
          className="mt-8 w-full rounded-full border-2 border-[#FF107A] text-[#FF107A] py-3 font-bold flex items-center justify-center gap-2 hover:bg-[#FF107A]/10"
        >
          <Trash2 size={16} /> Reset demo data
        </button>

        <p className="mt-8 text-[11px] tracking-[0.25em] uppercase text-[#FDFBF7]/40 text-center">
          Celebrity Smash — v0.1 proof of concept
        </p>
      </div>
    </div>
  );
}
